import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromMeasurementResults from './measurement-results.reducer';
import { EffectsModule } from '@ngrx/effects';
import { MeasurementResultsEffects } from './measurement-results.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromMeasurementResults.measurementResultsFeatureKey,
      fromMeasurementResults.reducer
    ),
    EffectsModule.forFeature([MeasurementResultsEffects]),
  ],
})
export class MeasurementResultsStoreModule {}
